import { Box, CircularProgress, Grid, Typography } from '@mui/material';

import { convertToCamelCase } from '@shared/helpers';
import FormCheckAvailavility from '@shared/pages/Hotels/FormCheckAvailavility';

import SeeRefundability from '../../../helpers/SeeRefundability';

import { useRoomBookingActions } from './useRoomBookingActions';
import NonRefundableDialog from './NonRefundableDialog';
import SeeMoreDialog from './SeeMoreDialog';
import RoomBookingCard from './RoomBookingCard';
import { sxStyle } from './styles';
import { CustomDialogModal, InfoDialogModal } from '@shared/components/Dialogs';
import RoomCardBlock from './RoomCardBlock';
import { listRooms } from './helper';
import BookingValuationModalFlow from '@shared/pages/Hotels/helpers/BookingValuationModalFlow';
import { hasValidContent } from '@shared/pages/Hotels/helpers/Remarks/hasValidContent';

const RoomRow = ({
  room,
  index,
  id_integration,
  check_in,
  id_hotel,
  total_passangers,
  total_nights,
  id_provider,
  data,
  urlToken,
  hotelCode,
  idCity,
  canBuy,
  canBook,
  canBookNoRef,
  integration,
  supplier_code,
}) => {
  const {
    // 🔹 UI reactiva
    showModal,
    setShowModal,
    messageModal,
    setMessageModal,
    showModalSeeMore,
    setShowModalSeeMore,
    showNonRefundableDialog,
    setShowNonRefundableDialog,
    priceTooltip,
    setPriceTooltip,
    usdUserTooltip,
    setUsdUserTooltip,
    loading,
    validationError,
    hotelCancelationFeeError,
    valuationChanges,
    showValuationModal,

    // 🔹 Lógica inmediata
    clickedBuyButton,

    // 🔹 Funciones
    validateHotelBeforeContinue,
    handleNonRefundableAccept,
    handleNoCancelable,
    handleNoCancelableBuy,
    handleCancelable,
    handleCancelableBuy,
    continueAfterValuation,
    onCheckCancellationFee,
    closeValuationModal,
    closeModalAndContinue,
    handleMouseEnter,
    handleMouseLeave,
    business_types,
    screenSize,
    price,
    cancelationFee,
    compare,
    acceptOnlyRef,
    checkingCancellation,
  } = useRoomBookingActions({
    room,
    id_integration,
    id_hotel,
    id_provider,
    urlToken,
    hotelCode,
    idCity,
    supplier_code,
  });

  let guestText;
  if (total_passangers === 1) {
    guestText = 'huésped,';
  } else {
    guestText = 'huéspedes,';
  }

  let roomText;
  if (room.rooms.length === 1) {
    roomText = '1 Habitación';
  } else {
    roomText = `${room.rooms.length} Habitaciones`;
  }

  const roomInfoText = `${total_passangers} ${guestText} ${roomText}`;

  const hasRemarks = hasValidContent(room?.general_comments);

  return (
    <Box sx={sxStyle.tableStyles}>
      <Grid container sx={sxStyle.contentRowsColumns}>
        <RoomCardBlock title="Tipo habitación">
          <Typography sx={sxStyle.subTitlesText}>{roomInfoText}</Typography>

          <Typography component="div" sx={sxStyle.subTitlesText}>
            {listRooms(room.rooms).map(roomvalue => (
              <p style={{ margin: 0 }} key={roomvalue.name}>
                {roomvalue.quantity} {convertToCamelCase(roomvalue.name)}
              </p>
            ))}
          </Typography>
        </RoomCardBlock>

        <RoomCardBlock title="Régimen de comida">
          <Typography sx={sxStyle.subTitlesText}>
            {convertToCamelCase(room.board.description)}
          </Typography>
        </RoomCardBlock>

        <RoomCardBlock title="Tipo tarifa">
          {loading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                padding: '10px 0',
              }}
            >
              <CircularProgress size={24} />
            </div>
          ) : (
            <>
              <SeeRefundability
                index={index}
                check_in={check_in}
                cancelationFee={cancelationFee}
                validateHotelBeforeContinue={validateHotelBeforeContinue}
                onCheckCancellationFee={onCheckCancellationFee}
                validationError={validationError}
                hotelCancelationFeeError={hotelCancelationFeeError}
                checkingCancellation={checkingCancellation}
              />
              {hasRemarks > 0 && (
                <SeeMoreDialog
                  open={showModalSeeMore}
                  onOpen={() => setShowModalSeeMore(true)}
                  onClose={() => setShowModalSeeMore(false)}
                  room={room}
                />
              )}
            </>
          )}
        </RoomCardBlock>

        <RoomBookingCard
          index={index}
          room={room}
          price={price}
          compare={compare}
          setUsdUserTooltip={setUsdUserTooltip}
          usdUserTooltip={usdUserTooltip}
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
          data={data}
          priceTooltip={priceTooltip}
          setPriceTooltip={setPriceTooltip}
          total_nights={total_nights}
          total_passangers={total_passangers}
          canBuy={canBuy}
          canBook={canBook}
          canBookNoRef={canBookNoRef}
          cancelationFee={cancelationFee}
          clickedBuyButton={clickedBuyButton}
          loading={loading}
          screenSize={screenSize}
          handleCancelableBuy={handleCancelableBuy}
          handleCancelable={handleCancelable}
          handleNoCancelableBuy={handleNoCancelableBuy}
          handleNoCancelable={handleNoCancelable}
          setShowModal={setShowModal}
          integration={integration}
          business_types={business_types}
          validationError={validationError}
          hotelCancelationFeeError={hotelCancelationFeeError}
        />

        {showModal && (
          <CustomDialogModal
            open={showModal}
            onClose={() => setShowModal(false)}
          >
            <FormCheckAvailavility
              closeModalHandler={modalState => setShowModal(modalState)}
              showMessage={show => setMessageModal(show)}
            />
          </CustomDialogModal>
        )}
        {messageModal && (
          <InfoDialogModal
            isOpen={messageModal}
            onClose={() => setMessageModal(false)}
            title="Consulta de alojamiento"
            text="Gracias por su consulta, en breve nos contactaremos con usted"
          />
        )}

        <NonRefundableDialog
          open={showNonRefundableDialog}
          onClose={() => setShowNonRefundableDialog(false)}
          onAccept={handleNonRefundableAccept}
        />

        <BookingValuationModalFlow
          showChangesModal={showValuationModal}
          valuationChanges={valuationChanges}
          supplier={data.supplier}
          id_product={room.id_product}
          id_integration={id_integration}
          compare={compare}
          total_nights={total_nights}
          total_passangers={total_passangers}
          check_in={check_in}
          onCancelChanges={closeValuationModal}
          onConfirmChanges={() => closeModalAndContinue(continueAfterValuation)}
          onAceptChanges={closeValuationModal}
          acceptOnly={acceptOnlyRef.current}
        />
      </Grid>
    </Box>
  );
};

export default RoomRow;
